import { Button, Group, Stack, Text, Title } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useInfoModal = () => {
  const navigate = useNavigate();

  const openLoginSuccessModal = () => {
    return modals.openConfirmModal({
      title: 'Login Successful',
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <Text size="sm">
          You have been logged in successfully. You will be automatically routed to the home page in 5 seconds.
        </Text>
      ),
      labels: { confirm: 'Ok' },
      confirmProps: {
        onClick: () => navigate("/")
      }
    });
  }

  const openLoginFailureModal = (errMessage) => {
    return modals.openConfirmModal({
      title: 'Login Failed',
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <Text size="sm">
          {errMessage}
        </Text>
      ),
      labels: { confirm: 'Ok' },
    });
    }

    const openGeneralInfoModal = (message) => {
        return modals.openConfirmModal({
            title: 'Info',
            centered: true,
            cancelProps: {
                size: 0
            },
            children: (
                <Text size="sm">
                    {message}
                </Text>
            ),
            labels: { confirm: 'Ok' },
        });
    }


  const openResetPasswordSuccessModal = () => {
    return modals.openConfirmModal({
      title: 'Password Reset Request Sent',
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <Text size="sm">
          Your password reset request has been sent. You should receive an email shortly containing the reset instructions.
        </Text>
      ),
      labels: { confirm: 'Ok' },
      confirmProps: {
        onClick: () => navigate("/")
      }
    });
  }

  const openResetPasswordFailureModal = (errMessage) => {
    return modals.openConfirmModal({
      title: 'Password Reset Request Failed',
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <Text size="sm">
          {errMessage}
        </Text>
      ),
      labels: { confirm: 'Ok' },
    });
  }

  const openGeneralFailureModal = (errMessage) => {
    return modals.openConfirmModal({
      title: 'Error',
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <Text size="sm">
          {errMessage || "Request Failed."}
        </Text>
      ),
      labels: { confirm: 'Ok' },
    });
  }

  const openGeneralSuccessModal = (message) => {
    return modals.openConfirmModal({
      title: 'Success',
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <Text size="sm">
          {message || "Request Succeeded!"}
        </Text>
      ),
      labels: { confirm: 'Ok' },
    });
  }

  const openRegistrationFileFailureModal = (responseObj) => {
    return modals.openConfirmModal({
      title: <Group align='flex-start'>
        <IconX color='red' />
        <Title order={4}>Import Problems Occurred</Title>
      </Group>,
      centered: true,
      cancelProps: {
        size: 0
      },
      children: (
        <>
          <Text>
            {responseObj.errorMessage || "Request Failed."}
          </Text>
          {
            <>
              <Text underline fw={500} mt={25}>Rows with invalid data:</Text>
              {
                (responseObj.invalidCells?.length) > 0 && responseObj.invalidCells.map((ic, idx) => <Text key={idx}>- {ic}</Text>)
              }
            </>
          }
        </>
      ),
      labels: { confirm: 'Ok' },
    });
  }

  const openModal = (type, message) => {
    switch(type) {
      case 'loginFailure':
        openLoginFailureModal(message);
        break;
      case 'resetPasswordFailure':
        openResetPasswordFailureModal(message);
        break;
      case 'resetPasswordSuccess':
        openResetPasswordSuccessModal(message);
        break;
      case 'generalFailure':
        openGeneralFailureModal(message);
        break;
      case 'generalInfo':
        openGeneralInfoModal(message);
        break;
      case 'generalSuccess':
        openGeneralSuccessModal(message);
        break;
      case 'registrationFileFailure':
        openRegistrationFileFailureModal(message);
        break;
    }
  }

  return openModal;
}

export default useInfoModal;